import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatToolbar } from '@angular/material/toolbar';
import { LayoutActions } from '@core/layout/store';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { UserSelectors } from '../store';
import { UserAvatarComponent } from '../user-avatar/user-avatar.component';

@Component({
  selector: 'app-user-panel',
  templateUrl: './user-panel.component.html',
  styleUrls: ['./user-panel.component.scss'],
  imports: [MatToolbar, MatIconButton, MatIcon, UserAvatarComponent, AsyncPipe, TranslatePipe],
})
export class UserPanelComponent implements OnInit {
  private _store = inject(Store);

  currentUser$ = this._store.select(UserSelectors.getCurrentUser);

  constructor() {}

  ngOnInit(): void {}

  closeUserSidenav() {
    this._store.dispatch(new LayoutActions.CloseRightPanel());
  }
}
